import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useLocation, useNavigate } from 'react-router-dom';
import { Alert, Button, Card, DatePicker, Form, Input } from 'antd';
import styled from 'styled-components';
import { Wrapper } from 'pages/life/forget/styledComponents';
// import regIcon from 'assets/images/register-icon.svg';
// import { RegistrationFlowContext } from 'contexts/registration';
// import { RegistrationFormData } from 'contexts/registration/registrationFormData';
import { useRegistrationStateQuery } from 'hooks/useRegistrationStateQuery';
import { disabledDate, setErrorCodeFun } from 'utils';
// import { IconTitle } from 'components';
import { useValidateEbUser } from 'all-in-one-shared-api';
import PolicyAndMemberIdModal from '../../forget/PolicyAndMemberIdModal';
// import { BoldLabelFormItem } from 'components/form/BoldLabelFormItem';
// import { revalidateAntdFormLanguageChanged } from '../../../../i18n';
import { StyledTitle } from 'components/StyledTitle';
import ProgressSteps from '../components/ProgressSteps';
import { InfoCircleOutlined } from '@ant-design/icons';
import './EbConnect.less';
// import _get from 'lodash/get';
import moment from 'moment';
import { BoldLabelFormItem } from 'components/form/BoldLabelFormItem';
import { useQuery } from 'hooks';
import { NamePath } from 'rc-field-form/es/interface';
export type FormData = {
  policyNumber?: string;
  memberId?: string;
  date?: string;
  dob?: string;
  dob1?: string;
};
const RegistrationCard = styled(Card)`
  width: 100%;
  border-radius: 8px;
  padding: 16px;
  margin-top: 16px;
`;

// const FormWrapper = styled.div`
//   display: grid;
//   row-gap: 12px;
//   max-width: 510px;
// `;

function EbConnectPolicy() {
  // const [ApiError, setApiError] = useState<string | null>(null);
  const { t, i18n } = useTranslation();
  const initialValues = useRegistrationStateQuery();
  // const [registrationState, setRegistrationState] = useState<RegistrationFormData>(initialValues);
  // const { dispatch } = useContext(RegistrationFlowContext);
  // const [mobilePrefix, setMobilePrefix] = useState(initialValues.countryCode || defaultPrefix);
  const navigate = useNavigate();
  const [snackbarMessage, setSnackbarMessage] = useState(initialValues.registerError || '');
  const [isModalVisible, setIsModalVisible] = React.useState(false);
  // const emailRef = React.useRef<InputRef>(null);
  const [form] = Form.useForm();
  const [randoms, setRandoms] = useState(0);
  const [validateEbError, setValidateEbError] = useState('');
  const [errors, setErrors] = useState<string | null>(null);
  const [errorsmsg, setErrorsmsg] = useState<string>('');

  const [form1, setForm1] = useState((): FormData => {
    return {
      policyNumber: '',
      memberId: '',
      date: '',
      dob1: '',
    };
  });
  const urlQuery = useQuery();

  const {
    shouldFetch: shouldFetchEbvalidate,
    data: ValidateEbData,
    error: ValidateEbError,
    isLoading,
  } = useValidateEbUser(
    'useValidateEbUser' + randoms,
    form1.policyNumber || '',
    form1.memberId || '',
    moment(form1.date).format('DD/MM/YYYY') || '',
    urlQuery.get('memberType') || '0',
  );
  const location = useLocation() as {
    state: {
      policyNumber: string;
      memberId: string;
      birthDate: string;
      memberType: '0';
      registNum?: boolean;
    };
  };
  const [outLink, setOutLink] = useState(false);
  /* eslint-disable */
  useEffect(() => {
    return () => {
      shouldFetchEbvalidate(false);
    };
  }, []);
  useEffect(() => {
    const registrationPart = urlQuery.get('dob1');
    console.log(urlQuery.get('memberType'), 'urlQuery=========');
    if (registrationPart) {
      form.setFieldValue('dob1', moment(registrationPart));
    }
    setForm1({
      ...form,
      dob1: urlQuery.get('dob1') || undefined,
      memberId: urlQuery.get('memberId') || undefined,
      policyNumber: urlQuery.get('policyNumber') || undefined,
    });
    setOutLink(true);
  }, [urlQuery]);
  useEffect(() => {
    // console.log(ValidateEbError, "lllc");

    if (ValidateEbData && !ValidateEbError) {
      // shouldFetchEbvalidate(false);
      navigate('/register/EbCreateProfile', {
        state: {
          policyNumber: form1.policyNumber,
          memberId: form1.memberId,
          birthDate: moment(form1.date).format('DD/MM/YYYY'),
          memberType: urlQuery.get('memberType') ? urlQuery.get('memberType') : '0',
          ValidateEbData: ValidateEbData,
          registNum: location?.state?.registNum,
          // 第三方跳转过来的
          loginId: urlQuery.get('loginId'),
          password: urlQuery.get('password'),
          confirmPassword: urlQuery.get('password'),
          email: urlQuery.get('email'),
          outLink,
        },
      });
    }
    if (ValidateEbError?.code && ValidateEbError?.message) {
      shouldFetchEbvalidate(false);
      setErrors(ValidateEbError.code);
      setErrorsmsg(ValidateEbError.message);
      const message = setErrorCodeFun(ValidateEbError.code, i18n.language);
      setValidateEbError(message ?? ValidateEbError.message);
      // shouldFetchEbvalidate(false);
    }
    if (i18n.language && errors) {
      const message = setErrorCodeFun(errors, i18n.language);
      setValidateEbError(message ?? errorsmsg);
    }
    console.log(form1);
  }, [ValidateEbData, ValidateEbError, i18n.language, errors, errorsmsg]);
  /* eslint-disable */
  const handleCloseSnackbar = () => {
    setValidateEbError('');
    setSnackbarMessage('');
  };
  function onValidateSuccessful(event?: React.BaseSyntheticEvent) {
    event && event.preventDefault();
    setRandoms(Math.random());
    shouldFetchEbvalidate(true);
  }
  useEffect(() => {
    let name: NamePath[] | undefined = [];
    form.getFieldsError().forEach((d) => {
      if (d.errors.length && d.name) {
        name = name?.concat(d.name);
      }
    });
    console.log(form.getFieldsError(), 'form.getFieldsError()');

    if (form.getFieldsError().some((errors) => errors.errors.length)) {
      form.validateFields(name);
    }
  }, [i18n.language]);
  const onFinish = (values: FormData) => {
    // dispatch({ type: ActionType.UpdateFormData, payload: values }); //提交时注释掉
    console.log(values, '================');
    setForm1({
      ...form1,
      policyNumber: values.policyNumber,
      memberId: values.memberId,
      date: values.dob1,
    });
    onValidateSuccessful();
    // navigate('/register/LifeRegistrationSubmission'); //提交时注释掉
    // setRegistrationState({
    //   identityNo: values.identityNo,
    //   dob: values.dob,
    // });
  };
  const closeModel = () => {
    setIsModalVisible(false);
  };
  const showModal = () => {
    setIsModalVisible(true);
  };
  // const prefixSelector = <MobileNumberPrefix handleChange={handleChange} />;
  const infoIcon = <InfoCircleOutlined style={{ cursor: 'pointer' }} onClick={showModal} />;

  return (
    <div
      className="eb_connect_wrapper"
      style={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        backgroundColor: 'transparent',
      }}
    >
      <RegistrationCard
        style={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          width: '100%',
          backgroundColor: 'white',
          borderRadius: '0',
        }}
      >
        <ProgressSteps activeStepIndex={0} />
        <Wrapper className="card_2" style={{ backgroundColor: 'white', borderRadius: 0, border: 0, paddingLeft: 0 }}>
          <div
            className="title"
            style={{
              display: 'flex',
              flexDirection: 'column',
              justifyContent: 'center',
              alignItems: 'center',
              // backgroundColor: 'pink',
              fontFamily: 'Roboto400',
              fontSize: 26,
            }}
          >
            <StyledTitle level={4}>{t('registration.EB.connectEBTitle')}</StyledTitle>
          </div>
          <div className="connectEBRemind">
            <StyledTitle level={5} type="secondary" margin="0 0 24px 0">
              {t('registration.EB.connectEBRemind')}
            </StyledTitle>
          </div>
          <StyledTitle className="secondary" level={5} type="secondary">
            {t('forgetLoginId.mandatoryMsg')}
          </StyledTitle>
          {!!snackbarMessage && (
            <Alert
              message={t(snackbarMessage)}
              type="error"
              // closable
              onClose={handleCloseSnackbar}
              style={{ marginBottom: 16 }}
            />
          )}
          <Form
            className="eb_connect_form"
            initialValues={initialValues}
            layout={'vertical'}
            requiredMark={false}
            onFinish={onFinish}
            form={form}
            validateTrigger={'onBlur'}
            style={{ width: '100%' }}
          >
            <div
              style={{
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'flex-start',
                alignItems: 'flex-start',
                width: '100%',
                // backgroundColor: 'pink',
              }}
            >
              <Form.Item
                label={t('life.forgetLoginId.policyNumber')}
                name="policyNumber"
                className="policyNumber"
                rules={[
                  { required: true, message: t('registration.error.required') },
                  // {
                  //   validator: (_, value) => {
                  //     if (value && !verifyPolicyNumber(value)) {
                  //       return Promise.reject(new Error(t('registration.error.invalidPolicyNumber')));
                  //     }
                  //     return Promise.resolve();
                  //   },
                  // },
                ]}
                style={{ marginBottom: 12, color: '#752127', width: '100%' }}
                tooltip={{ icon: infoIcon }}
              >
                <Input
                  maxLength={8}
                  disabled={outLink && urlQuery.get('policyNumber') ? true : false}
                  size="middle"
                  style={{
                    border: 'none',
                    borderBottom: '1px solid #E5E5E5',
                    // color: "white",
                    backgroundColor: 'transparent',
                  }}
                  onChange={(val) => {
                    setForm1({
                      ...form1,
                      policyNumber: val.target.value,
                    });
                  }}
                  placeholder={t('registration.EB.policyNumberHolder')}
                  // onKeyPress={(event) => {
                  //   if (!/[0-9a-zA-Z]/.test(event.key)) {
                  //     event.preventDefault();w
                  //   }
                  // }}
                />
              </Form.Item>
              <Form.Item
                label={t('life.forgetLoginId.memberId')}
                name="memberId"
                className="memberId"
                rules={[
                  { required: true, message: t('registration.error.required') },
                  // {
                  //   validator: (_, value) => {
                  //     if (value && !verifyMemberId(value)) {
                  //       return Promise.reject(new Error(t('registration.error.invalidPolicyNumber')));
                  //     }
                  //     return Promise.resolve();
                  //   },
                  // },
                ]}
                style={{ marginBottom: 12, color: '#752127', width: '100%' }}
                tooltip={{ icon: infoIcon }}
              >
                <Input
                  disabled={outLink && urlQuery.get('memberId') ? true : false}
                  maxLength={12}
                  size="middle"
                  style={{
                    border: 'none',
                    borderBottom: '1px solid #E5E5E5',
                    // color: "white",
                    backgroundColor: 'transparent',
                  }}
                  onChange={(val) => {
                    setForm1({
                      ...form1,
                      memberId: val.target.value,
                    });
                  }}
                  placeholder={t('life.forgetLoginId.enterMemberId')}
                  // onKeyPress={(event) => {
                  //   if (!/[0-9a-zA-Z]/.test(event.key)) {
                  //     event.preventDefault();
                  //   }
                  // }}
                />
              </Form.Item>
              <BoldLabelFormItem
                className="dob1"
                label={t('registration.dobLabel') + '*'}
                name="dob1"
                rules={[{ required: true, message: t('registration.error.required') }]}
                style={{ width: '100%' }}
              >
                <DatePicker
                  disabledDate={disabledDate}
                  disabled={outLink && urlQuery.get('dob1') ? true : false}
                  onChange={(e) => {
                    setForm1({
                      ...form1,
                      dob1: e ? moment(e).format('DD/MM/YYYY') : undefined,
                    });
                  }}
                  placeholder={t('common.placeholder.date')}
                  format="DD/MM/YYYY"
                  style={{
                    border: 'none',
                    borderBottom: '1px solid #E5E5E5',
                    color: 'white',
                    backgroundColor: 'transparent',
                    width: '100%',
                  }}
                />
              </BoldLabelFormItem>
              {validateEbError && (
                <div style={{ width: '100%', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                  <Alert
                    message={validateEbError}
                    className="error-register"
                    type="error"
                    // closable
                    onClose={handleCloseSnackbar}
                    style={{ marginBottom: 0 }}
                  />
                </div>
              )}
              <div
                style={{
                  display: 'flex',
                  flexDirection: 'column',
                  justifyContent: 'center',
                  alignItems: 'center',
                  width: '100%',
                  // backgroundColor: 'pink',
                }}
              >
                <Form.Item style={{ width: 428 }} className="form_btn">
                  <Button
                    block
                    className="btn"
                    type="primary"
                    disabled={!form1.dob1 || !form1.memberId || !form1.policyNumber}
                    loading={isLoading}
                    style={{ fontFamily: 'Roboto500', fontSize: 20 }}
                    size="large"
                    htmlType="submit"
                  >
                    {t('common.submit')}
                  </Button>
                </Form.Item>
                {/* <Link
                  style={{
                    fontWeight: 'normal',
                    marginLeft: 4,
                    marginRight: 4,
                    color: '#C21B17',
                    textDecoration: 'underline',
                  }}
                  to="/forgot/login"
                >
                  {t('life.forgetLoginId.Needhelp')}
                </Link> */}
              </div>
            </div>
          </Form>
        </Wrapper>
      </RegistrationCard>
      <PolicyAndMemberIdModal isModalVisible={isModalVisible} handleModalClose={closeModel} />
    </div>
  );
}

export default EbConnectPolicy;
